import { action } from "mobx";
import NestStore from "~/stores/NestStore";
import CreditPurchaseRepository from "~/repository/Credit/CreditPurchaseRepository";

class CreditPurchaseStore extends NestStore {
  creditPurchaseRepository = null;

  constructor() {
    super();

    this.creditPurchaseRepository = new CreditPurchaseRepository();
  }

  @action
  create(data) {
    this.isSaving = true;

    return this.creditPurchaseRepository
      .create(data)
      .catch(e => {
        this.isSaving = false;
        this.setErrorMessages(e);
        throw e;
      })
      .finally(() => {
        this.isSaving = false;
      });
  }
}

export default CreditPurchaseStore;
